import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import {TenantSubscriptionModel} from "../../../../../models/aggregates/tenant-subscription";

// https://api.akaun.dev/core2/platform/dm/tenant-subscriptions

@Injectable({
  providedIn: 'root'
})
export class TenantSubscriptionService extends BaseApiTemplateService<TenantSubscriptionModel> {
  protected apiUrl: string;

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'tenant-subscriptions';
    this.httpClient = http;
  }

}
